'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _commonFormsy = require('../common-formsy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PasswordResetRequest = (0, _classAutobindDecorator2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(PasswordResetRequest, _Component);

  function PasswordResetRequest() {
    _classCallCheck(this, PasswordResetRequest);

    return _possibleConstructorReturn(this, (PasswordResetRequest.__proto__ || Object.getPrototypeOf(PasswordResetRequest)).apply(this, arguments));
  }

  _createClass(PasswordResetRequest, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Password reset'
        ),
        _react2.default.createElement(
          'div',
          null,
          'Please enter the email address or username you use to sign in to ',
          _react2.default.createElement(
            'strong',
            null,
            window.Mighty.API_HOST
          ),
          ' and a password reset link will be sent to your email address.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _commonFormsy.Form,
          { onValidSubmit: this.props.handleSubmit },
          _react2.default.createElement(_commonFormsy.Input, {
            name: 'email',
            placeholder: 'Email or Username',
            required: true,
            type: 'text',
            validationError: 'Not a valid email'
          }),
          _react2.default.createElement(
            _Button2.default,
            { type: 'submit', bsStyle: 'primary', bsSize: 'small' },
            'Request reset link'
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PasswordResetRequest;
}(_react.Component), _class2.propTypes = {
  handleSubmit: _propTypes2.default.func
}, _temp)) || _class;

var _default = PasswordResetRequest;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PasswordResetRequest, 'PasswordResetRequest', '/app/src/components/page-password-reset/PasswordResetRequest.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-password-reset/PasswordResetRequest.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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